module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n<div class=\"history-item\">\n  <div class=\"card border-dark\">\n    <div class=\"card-header\" id=\"historyItem")
    ; __append(escapeFn( index ))
    ; __append("\">\n      <h2 class=\"mb-0\">\n        <button class=\"btn btn-link\" type=\"button\" data-toggle=\"collapse\" data-target=\"#historyItemBody")
    ; __append(escapeFn( index ))
    ; __append("\" aria-expanded=\"true\" aria-controls=\"collapse$")
    ; __append(escapeFn( index ))
    ; __append("\">\n                From ")
    ; __append(escapeFn( event.actor ))
    ; __append(" (")
    ; __append(escapeFn( event.actor_role ))
    ; __append(") on ")
    ; __append(escapeFn( getHumanReadableDate(event.date) ))
    ; __append("\n          ")
    ; if (event.new_status !== null) { 
    ; __append("\n          <span style=\"padding-left: 10px;\">New status:</span> ")
    ; __append(escapeFn( swh.add_forge.formatRequestStatusName(event.new_status) ))
    ; __append("\n          ")
    ;  } 
    ; __append("\n        </button>\n      </h2>\n    </div>\n    <div id=\"historyItemBody")
    ; __append(escapeFn( index))
    ; __append("\" class=\"collapse\" aria-labelledby=\"historyItem")
    ; __append(escapeFn( index ))
    ; __append("\" data-parent=\"#requestHistory\">\n      <div class=\"card-body\">\n        ")
    ; if (event.text) { 
    ; __append("\n        <pre>")
    ; __append(escapeFn( event.text ))
    ; __append("</pre>\n        ")
    ;  } 
    ; __append("\n        ")
    ; if (event.message_source_url !== null) { 
    ; __append("\n        <p><a href=\"")
    ; __append(escapeFn( event.message_source_url ))
    ; __append("\">Open original message in email client</a></p>\n        ")
    ;  } 
    ; __append("\n        ")
    ; if (event.new_status !== null) { 
    ; __append("\n          <p>\n           <span>Status changed to:</span> <strong>")
    ; __append(escapeFn( swh.add_forge.formatRequestStatusName(event.new_status) ))
    ; __append("</strong>\n          </p>\n        ")
    ;  } 
    ; __append("\n      </div>\n    </div>\n  </div>\n</div>\n")
  }
  return __output;

}